import type { SummaryState, SummaryAction } from "./types";

export const initialState: SummaryState = {
  summaries: {},
  loadingStates: {},
  errors: {},
  streamingStates: {},
};

export function summaryReducer(state: SummaryState, action: SummaryAction): SummaryState {
  switch (action.type) {
    case "START_LOADING":
      return {
        ...state,
        loadingStates: { ...state.loadingStates, [action.cacheKey]: true },
        errors: { ...state.errors, [action.cacheKey]: "" },
        streamingStates: { ...state.streamingStates, [action.cacheKey]: false },
      };

    case "START_STREAMING":
      return {
        ...state,
        streamingStates: { ...state.streamingStates, [action.cacheKey]: true },
        loadingStates: { ...state.loadingStates, [action.cacheKey]: false },
      };

    case "UPDATE_CONTENT": {
      const existingSummary = state.summaries[action.cacheKey];
      if (existingSummary && existingSummary.content === action.content) {
        return state;
      }
      return {
        ...state,
        summaries: {
          ...state.summaries,
          [action.cacheKey]: {
            ...state.summaries[action.cacheKey],
            content: action.content,
          },
        },
      };
    }

    case "SET_SUMMARY":
      return {
        ...state,
        summaries: { ...state.summaries, [action.cacheKey]: action.summary },
        loadingStates: { ...state.loadingStates, [action.cacheKey]: false },
        streamingStates: { ...state.streamingStates, [action.cacheKey]: false },
        errors: { ...state.errors, [action.cacheKey]: "" },
      };

    case "SET_ERROR":
      return {
        ...state,
        errors: { ...state.errors, [action.cacheKey]: action.error },
        loadingStates: { ...state.loadingStates, [action.cacheKey]: false },
        streamingStates: { ...state.streamingStates, [action.cacheKey]: false },
      };

    case "CLEAR_ERROR":
      return {
        ...state,
        errors: { ...state.errors, [action.cacheKey]: "" },
      };

    case "CLEAR_SUMMARY": {
      const newSummaries = { ...state.summaries };
      const newLoadingStates = { ...state.loadingStates };
      const newErrors = { ...state.errors };
      const newStreamingStates = { ...state.streamingStates };

      delete newSummaries[action.cacheKey];
      delete newLoadingStates[action.cacheKey];
      delete newErrors[action.cacheKey];
      delete newStreamingStates[action.cacheKey];

      return {
        summaries: newSummaries,
        loadingStates: newLoadingStates,
        errors: newErrors,
        streamingStates: newStreamingStates,
      };
    }

    case "CLEAR_ALL":
      return initialState;

    default:
      return state;
  }
}
